"use client";

import * as m from "motion/react-m";
import { useTranslations } from "next-intl";

import { StudioEditorMockDashboard } from "@ui/components/MockDashboards";

const CARD_SHADOW = "0px 2px 4px 0px rgba(0, 0, 0, 0.078), 0px 0px 0px 0.9px rgba(0, 0, 0, 0.071)";

export function StudioEditorDemo() {
  const t = useTranslations("ClientKeys.BlockStickyContentList.StudioEditorDemo");

  return (
    <div
      className='tw-h-full tw-pl-2 tw-pb-2 sm:tw-pl-3 sm:tw-pb-3 md:tw-pl-4 md:tw-pb-4'
      role='img'
      aria-label={t("aria_label")}
      inert
    >
      <m.div
        className='tw-h-full tw-rounded-bl-2xl tw-overflow-hidden'
        initial={{ y: 150 }}
        animate={{ y: 0 }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 50,
        }}
        style={{
          boxShadow: CARD_SHADOW,
        }}
      >
        <StudioEditorMockDashboard />
      </m.div>
      <div className='tw-absolute tw-inset-x-0 tw-top-0 tw-h-14 tw-bg-gradient-to-b tw-from-[#FDFCFC] tw-to-transparent tw-pointer-events-none' />
    </div>
  );
}
